import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { useToast } from '@/hooks'
import { useFilingMutations } from '@/modules/tools/bankruptcy/hooks'
import { useDialogActions, useDialogData, useDialogIsOpen } from '@/stores'

export const REMOVE_DOCUMENT_DIALOG_ID = 'remove-bankruptcy-document'

interface RemoveDocumentPayload {
  filingId: number
  documentId: number
  fileName: string | null
}

export const RemoveDocumentDialog = () => {
  const open = useDialogIsOpen(REMOVE_DOCUMENT_DIALOG_ID)
  const { closeDialog } = useDialogActions()
  const data = useDialogData() as RemoveDocumentPayload | undefined
  const { removeDocument } = useFilingMutations()
  const { successToast, errorToast } = useToast()

  const onConfirm = () => {
    if (!data) return

    removeDocument(data.filingId, data.documentId)
      .then(() => successToast('Document removed'))
      .catch((error) => errorToast('Failed to remove the document', error))
    closeDialog(true)
  }

  return (
    <Dialog open={open} onOpenChange={(next) => !next && closeDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove document?</DialogTitle>
          <DialogDescription>
            This removes{' '}
            {data?.fileName ? `"${data.fileName}"` : 'this document'} from the
            case and frees its pages. Re-screen to update the figures.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-4">
          <Button theme="outline" onClick={() => closeDialog()}>
            Cancel
          </Button>
          <Button theme="danger" onClick={onConfirm}>
            Remove document
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
